import styled, { css } from 'styled-components';

import palette from '@utils/theme/palette';
import { GetSCProps, PaletteColor } from '@utils/types';

export const Span = styled.span<{ promotionClub?: boolean }>`
  font-size: 12px;
  min-height: 15px;
  line-height: normal;
  color: ${({ promotionClub, theme }) =>
    promotionClub ? theme.palette.persianRed : theme.palette.clearBlue};
`;
export const IconWrapper = styled.div`
  font-size: 14px;
  font-weight: 600;
  padding: 0px 0px 0px 15px;
`;
export const InfoBoxWrapper = styled.div<{
  fullWidthAt: number;
  advancePayment: boolean;
  width?: string;
  padding?: string;
  margin?: string;
  promotionClub?: boolean;
  minHeight?: string;
  justifyContent?: string;
}>`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 8px;
  justify-content: ${({ justifyContent }) =>
    justifyContent ? 'end' : 'start'};
  padding: ${(p) => p.padding ?? '10px'};
  min-height: ${(p) => p.minHeight ?? '40px'};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    justify-content: space-between !important;
  }
  gap: 12px;
  background: ${({ promotionClub }) =>
    promotionClub ? palette.lightRed : palette.blueDark};

  ${(p) =>
    p.advancePayment &&
    css`
      padding-right: 0;
      align-items: start;
      align-self: center;
    `}
  ${(p) =>
    p.width &&
    css`
      width: ${p.width};
    `}
  ${(p) =>
    p.margin &&
    css`
      margin: ${p.margin};
    `};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 10px;
    gap: 2px;
    justify-content: flex-start;
  }
`;
export const TimeText = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.B500};
`;
export const InfoNoteMessage = styled.span``;

export type InfoNoteContainerProps = GetSCProps<
  'backgroundColor' | 'color' | 'noMargin' | 'padding'
> & {
  variant?: 'hes' | 'generic' | 'warning' | 'verification' | 'info';
  hideIcon?: boolean;
  customCss?: ReturnType<typeof css>;
};

const noteVariantMixin = ({ variant, theme }: InfoNoteContainerProps) => {
  switch (variant) {
    case 'verification':
      return css`
        outline: dashed 1px;
        background-color: ${theme?.palette.hesInfoBoxBackground};
        color: ${theme?.palette.fadedOrange};
      `;
    case 'hes':
      return css`
        outline: dashed 1px;
        min-height: 65px;
        background-color: ${theme?.palette.hesInfoBoxBackground};
        color: ${theme?.palette.fadedOrange};
      `;
    case 'info':
      return css`
        background-color: ${theme?.palette.hesInfoBoxBackground};
        color: ${theme?.palette.fadedOrange};
      `;
    case 'warning':
      return css`
        background-color: ${theme?.palette.coral_01};
        color: ${theme?.palette.coral};
      `;
    default:
      return null;
  }
};

export const InfoNoteBox = styled.div<InfoNoteContainerProps>`
  display: flex;
  margin: ${({ noMargin }) => (noMargin ? undefined : '20px 0 42px')};
  padding: ${(p) => p.padding ?? '15px 20px 15px 15px'};
  border-radius: 8px;
  background-color: ${({ backgroundColor, theme: { palette } }) =>
    palette[backgroundColor as PaletteColor] ?? backgroundColor};
  color: ${({ theme: { palette }, color }) =>
    palette[color as PaletteColor] ?? color};
  ${InfoNoteMessage} {
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 0 ${(p) => (p.hideIcon ? 0 : 15)}px;
    line-height: normal;
    min-height: ${(p) => (p.variant === 'hes' ? '35px' : 'unset')};
  }
  ${noteVariantMixin}
  ${({ customCss }) => customCss};
  *[data-role='custom-icon'] {
    align-self: flex-start;
  }
`;
